import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    this.preview = null
  }

  disconnect() {
    this.hidePreview()
  }

  showPreview(event) {
    // Create preview element if it doesn't exist
    if (!this.preview) {
      this.preview = document.createElement('div')
      this.preview.className = 'fixed z-50 pointer-events-none'
      this.preview.style.display = 'none'

      const img = document.createElement('img')
      img.src = this.urlValue
      img.className = 'border rounded-lg shadow-2xl max-w-md max-h-96 object-contain bg-white'

      this.preview.appendChild(img)
      document.body.appendChild(this.preview)
    }

    // Show preview
    this.preview.style.display = 'block'
    this.updatePosition(event)

    // Add mousemove listener to update position
    this.element.addEventListener('mousemove', this.updatePosition.bind(this))
  }

  hidePreview() {
    if (this.preview) {
      this.preview.style.display = 'none'
      this.element.removeEventListener('mousemove', this.updatePosition.bind(this))
    }
  }

  updatePosition(event) {
    if (!this.preview) return

    // Position to the right of the cursor with some offset
    const offsetX = 20
    const offsetY = -50

    let left = event.clientX + offsetX
    let top = event.clientY + offsetY

    // Ensure preview doesn't go off screen
    const previewRect = this.preview.getBoundingClientRect()
    const windowWidth = window.innerWidth
    const windowHeight = window.innerHeight

    // Adjust if going off right edge
    if (left + previewRect.width > windowWidth) {
      left = event.clientX - previewRect.width - offsetX
    }

    // Adjust if going off bottom edge
    if (top + previewRect.height > windowHeight) {
      top = windowHeight - previewRect.height - 10
    }

    // Adjust if going off top edge
    if (top < 0) {
      top = 10
    }

    this.preview.style.left = `${left}px`
    this.preview.style.top = `${top}px`
  }
}
